import { render, staticRenderFns } from "./RiskTemplateForm.vue?vue&type=template&id=6e565545&scoped=true&"
import script from "./RiskTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./RiskTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./RiskTemplateForm.vue?vue&type=style&index=0&id=6e565545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e565545",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContent,VForm,VProgressCircular})
